export default "__VITE_ASSET__CJVl5WYV__"